
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.998 5.982a1 1 0 011 1v4.005h4.018a1 1 0 01.993.884l.007.117a1 1 0 01-1 1h-4.019v4.03a1 1 0 01-.883.993l-.116.007a1 1 0 01-1-1v-4.03H6.983a1 1 0 01-.993-.884l-.007-.116a1 1 0 011-1h4.013V6.981a1 1 0 01.884-.993z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    